<template>
  <!-- 对齐 App order_list.dart：AppHeader + CardContainer + EmptyState + BottomNav -->
  <div class="order-page">
    <app-header :title="i18n.title"></app-header>

    <card-container>
      <div
        class="order-scroll"
        ref="scrollBox"
        @scroll="onScroll"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
      >
        <!-- 下拉刷新提示 -->
        <div class="order-refresh" v-if="refreshHint">
          <span v-if="refreshing">{{ i18nMsg.loading }}</span>
          <span v-else>↓ {{ i18nMsg.refresh || "Release to refresh" }}</span>
        </div>

        <!-- 列表内容 -->
        <div class="order-list" v-if="items.length">
          <order-item
            v-for="item in items"
            :key="item.pOrderid"
            :item="item"
          ></order-item>
        </div>

        <!-- 空状态（使用公共组件） -->
        <empty-state v-else-if="!loading" :text="i18nMsg.no_order || 'No orders'"></empty-state>

        <!-- 加载中 -->
        <div class="order-loading" v-if="loading && !items.length">
          <span>{{ i18nMsg.loading }}</span>
        </div>

        <!-- 到底提示 -->
        <div class="order-no-more" v-if="items.length && !hasMore && !loading">
          — {{ i18nMsg.list_nomore || "No more" }} —
        </div>

        <!-- 加载更多（如果还有更多） -->
        <div class="order-loading-more" v-if="items.length && hasMore && loading">
          <span>{{ i18nMsg.loading }}</span>
        </div>
      </div>

      <bottom-nav class="order-bottom-nav"></bottom-nav>
    </card-container>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { ORDER_LIST } from "../../apis/user"
import OrderItem from "../../components/order/item"
import AppHeader from "../../components/common/AppHeader.vue"
import CardContainer from "../../components/common/CardContainer.vue"
import EmptyState from "../../components/common/EmptyState.vue"
import BottomNav from "../../components/common/BottomNav.vue"

export default {
  components: {
    OrderItem,
    AppHeader,
    CardContainer,
    EmptyState,
    BottomNav
  },
  computed: {
    i18n() {
      return this.$t("order")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  data() {
    return {
      items: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      refreshing: false,
      refreshHint: false,
      touchStartY: 0,
      pullDistance: 0,
      scrollLoading: false
    }
  },
  methods: {
    // 对齐 App getOrderList：cdb/mine/order/list，参数 page, pageSize
    loadList(page = 1) {
      if (this.loading) return
      if (page > 1 && !this.hasMore) return
      this.loading = true
      this.$loading(page === 1)
      this.$get(
        ORDER_LIST,
        { page, pageSize: this.pageSize },
        (resp) => {
          this.loading = false
          this.refreshing = false
          this.$loading(false)
          if (resp && resp.page) {
            const newItems = resp.page.records || []
            if (page === 1) {
              this.items = newItems
            } else {
              this.items = this.items.concat(newItems)
            }
            this.hasMore = newItems.length >= this.pageSize
            this.page = page
          } else {
            if (page === 1) this.items = []
            this.hasMore = false
          }
        },
        (error) => {
          this.loading = false
          this.refreshing = false
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onScroll(e) {
      const el = e.target
      const { scrollTop, scrollHeight, clientHeight } = el
      if (
        scrollHeight - scrollTop - clientHeight < 50 &&
        this.hasMore &&
        !this.loading
      ) {
        this.loadList(this.page + 1)
      }
    },
    onTouchStart(e) {
      this.touchStartY = e.touches[0].clientY
      this.pullDistance = 0
    },
    onTouchMove(e) {
      const scrollBox = this.$refs.scrollBox
      if (scrollBox && scrollBox.scrollTop <= 0) {
        const deltaY = e.touches[0].clientY - this.touchStartY
        if (deltaY > 0) {
          this.pullDistance = deltaY
          this.refreshHint = deltaY > 60
        }
      }
    },
    onTouchEnd() {
      if (this.pullDistance > 100 && this.refreshHint) {
        this.refreshing = true
        this.refreshHint = false
        this.loadList(1)
      } else {
        this.refreshHint = false
        this.pullDistance = 0
      }
    }
  },
  created() {
    this.loadList(1)
  },
  beforeDestroy() {
    this.$loading(false)
  }
}
</script>

<style lang="less" scoped>
.order-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: var(--page-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0 20px;
}

.order-refresh {
  padding: 20px 0;
  text-align: center;
  color: #999;
  font-size: 26px;
}

.order-list {
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.order-loading,
.order-loading-more {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 28px;
}

.order-no-more {
  padding: 40px 0;
  text-align: center;
  color: #c6c6c6;
  font-size: 26px;
}

.order-bottom-nav {
  margin-top: auto;
  padding-bottom: 30px;
}
</style>
